import { render, staticRenderFns } from "./treeUl.vue?vue&type=template&id=533f8ff1&"
import script from "./treeUl.vue?vue&type=script&lang=js&"
export * from "./treeUl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports